<ng-content select="iss-side-nav"/>
<div class="iss-side-nav-container">
  <ng-content select="[issPageContextBar]"/>
  <div class="is-hidden-tablet">
    <ng-content select="[issPageMobileAppBar]"/>
  </div>
  <iss-breadcrumbs></iss-breadcrumbs>
  <div class="is-hidden-mobile">
    <ng-content select="iss-page-title-bar"/>
  </div>
  <div class="iss-side-nav-container-content tui-zero-scrollbar">
      <div class="iss-container iss-side-nav-container-content-full" #ref>
          <ng-content/>
      </div>
  </div>
  <iss-side-nav-footer class="iss-side-nav-container__footer"></iss-side-nav-footer>
  <div class="is-hidden-tablet iss-side-nav-container__tab-bar">
    <ng-content select="[issPageMobileTabBar]"/>
  </div>
</div>
